import type { Company } from '../../Companies/Types/companyTypes';

export interface BookingExpenseInvoiceCompanyLookup {
  id: number;
  name: string;
}

export const mapCompanyToBookingExpenseInvoiceLookup = (
  company: Company | undefined | null
): BookingExpenseInvoiceCompanyLookup | undefined => {
  if (!company) {
    return undefined;
  }

  const normalizedName = company.name?.trim();
  if (!normalizedName) {
    return undefined;
  }

  return {
    id: company.id,
    name: normalizedName,
  };
};

